import { Header } from './Header';

interface LayoutProps {
  children: React.ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen flex flex-col bg-linear-to-b from-background to-muted/30">
      <Header />
      <main className="flex-1 flex flex-col">{children}</main>
    </div>
  );
}
